import HomePge from "@/pages/homePage"
export default function MainPage() {
  return (
    <div
      // style={{
      //   color: '#e1e1e1',
      //   display: 'block',
      //   alignItems: 'center',
      //   justifyItems: 'center',
      //   textAlign: 'center',
      //   lineHeight: 'calc(100vh - 142px)',
      //   fontSize: 32,
      // }}
    >
      <HomePge />
    </div>
  )
}
